import React, { Component } from 'react';
import Select from 'react-select';
import { HandleSubmit } from '../../func/HandleSubmit';
import ReactToPrint from "react-to-print";
import ReactTable from 'react-table-6'
import "react-table-6/react-table.css";
import matchSorter from 'match-sorter'
const StatusNum = {
    prepishfactor: 5,
    pishfactor: 10,
    factor: 20,
    tahvil: 30,
    preafzayesh: 55,
    laghv: 40,
    afzayesh: 60,
}

class ProgressDetailView extends Component {
    constructor(props) {

        super(props);
        this.state = {
            Loading: true,
            TableData: [],
            CommentData: {},
            SendParameters: {},
        };
        this.GetDataOfTable = this.GetDataOfTable.bind(this);
    }
    params = {
        request_code: this.props.request_code,
        progress: this.props.progress,
        nextprogress: this.props.nextprogress
    }
    async GetDataOfTable() {

        const response_info = await HandleSubmit('getdata/getdetailofrequest', this.params);
        this.state.TableData = (response_info.progress_row);
        this.state.CommentData = JSON.parse(response_info.progress_comment);
        // console.log("res2c", this.state.CommentData.driver_name);
        this.setState({
            TableData: this.state.TableData,
            CommentData: this.state.CommentData,
            Loading: false
        });
    }
    async componentDidMount() {
        this.setState({
            Loading: true
        });
        await this.GetDataOfTable();
        this.setState({
            Loading: false
        });
    }
    render() {
        if (this.state.Loading) { return "در حال بارگزاری..."; }
        return (
            <div>
                <div> شماره سفارش {this.props.request_code}</div>
                <ReactTable
                    className="-striped -highlight"
                    showPagination={false}
                    minRows={0}
                    defaultPageSize={100}
                    headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                    data={this.state.TableData}
                    columns={[
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 20,
                            Cell: (row) => (row.value + 1)
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> نام کالا </div>,
                            accessor: "kala_name",
                            maxWidth: 320,
                            minWidth: 200
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>انبار </div>,
                            accessor: "anbar_name",
                            show: (this.props.progress != StatusNum.afzayesh && this.props.progress != StatusNum.tahvil) ? false : true

                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>تعداد </div>,
                            accessor: "qty_value",
                        }
                    ]}
                    className="-striped -highlight"
                />
                <br />
                {(this.props.progress) == StatusNum.tahvil ?
                    <tr>
                        <td style={{ "textAlign": "left" }}> نام راننده: </td>
                        <td colSpan="2" style={{ "textAlign": "right" }}>
                            {this.state.CommentData.driver_name != null ? this.state.CommentData.driver_name : "ثبت نشده است"}
                        </td>
                    </tr>
                    : null}
                <div hidden="true">
                    <PrintDetailView
                        ref={el => (this.PrintDetailRef = el)}
                        TableOfInventory={this.state.TableData}
                        Sorttable={this.state.Sorttable}
                        progress={this.props.progress}
                        PageChangetable={this.state.PageChangetable}
                        PageSizetable={this.state.PageSizetable}
                        Filtertable={this.state.Filtertable}
                    />
                </div>
                <ReactToPrint
                    trigger={() => <button className="btn btn-outline-warning" >Print</button>}
                    content={() => this.PrintDetailRef}
                />
            </div>
        );
    }
}
export default (ProgressDetailView);

class PrintDetailView extends Component {
    // laboo = this.props.PageSizetable;
    constructor(props) {
        super(props);
    }
    componentDidUpdate() {
    }
    render() {
        return (
            <React.Fragment>
                <ReactTable
                    style={{ direction: "rtl", textAlign: "center", fontSize: "15px" }}
                    data={this.props.TableOfInventory}
                    showPagination={false}
                    pageSize={this.props.PageSizetable}
                    defaultSorted={this.props.Sorttable}
                    page={this.props.PageChangetable}
                    defaultFiltered={this.props.Filtertable}
                    columns={[
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 20,
                            Cell: (row) => (row.value + 1)
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> نام کالا </div>,
                            accessor: "kala_name",
                            maxWidth: 320,
                            minWidth: 200
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>انبار </div>,
                            accessor: "anbar_name",
                            show: (this.props.progress != StatusNum.afzayesh && this.props.progress != StatusNum.tahvil) ? false : true

                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>تعداد </div>,
                            accessor: "qty_value",
                        }
                    ]}
                    className="-striped -highlight"

                />
                <h1>Page {this.props.PageChangetable + 1}</h1>
            </React.Fragment>

        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/Progress/ProgressDetailView.js